/**
 * The buttons of the Bureau's cards, Encre (PLAN-BUREAU § 4 quater): pills of 36 px. One action
 * colour — AutoQuote's blue, in the widget's gradient (Gilles, 09/10/2026) — for the gesture that
 * moves things forward; a ringed pill for the alternatives; plain words for « Ne pas envoyer ». No
 * red for a forcing gesture: the sentence next to « Valider quand même » says what it costs (mock-up
 * « RDV : le créneau est déjà pris »). Shared so every card speaks the same language.
 */

/** The fill of the gesture that moves things forward: the widget's blue gradient, white text. */
export const ACCENT_FILL =
  'bg-gradient-to-br from-desk-accent to-desk-accent-2 text-white shadow-[0_6px_16px_-8px_rgb(var(--desk-accent)/0.6)] hover:brightness-[0.94]';
const BASE =
  'inline-flex h-9 shrink-0 items-center justify-center gap-1.5 whitespace-nowrap rounded-full text-sm font-medium transition focus:outline-none focus-visible:ring-2 focus-visible:ring-desk-focus focus-visible:ring-offset-2 focus-visible:ring-offset-desk-bg disabled:cursor-not-allowed disabled:opacity-40';

export const BTN_PRIMARY = `${BASE} ${ACCENT_FILL} px-3.5`;

export const BTN_SECONDARY = `${BASE} px-3.5 text-desk-ink ring-1 ring-inset ring-desk-ring hover:bg-desk-hover`;

export const BTN_GHOST = `${BASE} px-3.5 text-desk-soft hover:bg-desk-hover hover:text-desk-ink`;

/** « Confier à Otto »: the action of its card, so the blue. */
export const BTN_OTTO = BTN_PRIMARY;

/** « Demander à Otto un autre créneau », « Confier à Otto » beside other gestures. */
export const BTN_OTTO_SOFT = BTN_SECONDARY;

/** A gesture that forces or deletes: the same fill; its card says what it costs. */
export const BTN_DANGER = BTN_PRIMARY;

/** A 36 px square for an icon (Joindre, Dicter, « … »). */
export const BTN_ICON =
  'inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-[10px] text-desk-soft transition hover:bg-desk-hover hover:text-desk-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-desk-focus disabled:cursor-not-allowed disabled:opacity-40';

/** The buttons of a mission's header (Plus tard, « … »): quiet until hovered. */
export const BTN_HEADER =
  'inline-flex h-9 shrink-0 items-center gap-1.5 rounded-[10px] px-2.5 text-sm font-medium text-desk-soft transition hover:bg-desk-hover hover:text-desk-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-desk-focus';
